import React from "react"
import { FormField } from "src/features/calculator/components/field/FormField"
import styled from "styled-components"
import { FieldErrors, UseFormSetValue } from "react-hook-form"
import { CalculationSchema } from "src/features/calculator/schema"

type Props = {
  selfPayment: number
  initialCost: number
  maxAdvancePayment: number
  downPayment: number
  setValue: UseFormSetValue<CalculationSchema>
  errors: FieldErrors<CalculationSchema>
}

export function SelfPaymentRow({
  selfPayment,
  initialCost,
  maxAdvancePayment,
  downPayment,
  setValue,
  errors,
}: Props) {
  return (
    <StyledCalculatorRowDiv>
      <FormField
        label="自己負担額"
        type="number"
        placeholder="Placeholder"
        hint={`${selfPayment.toLocaleString()}円`}
        disabled
        value={selfPayment}
      />
      <span>= max (</span>
      <FormField
        label="初期費用総額"
        type="number"
        placeholder="Placeholder"
        hint={`${initialCost.toLocaleString()}円`}
        onChange={(e) => {
          setValue("initialCost", Number(e.target.value))
        }}
        errorText={errors?.initialCost?.message}
        value={initialCost}
      />
      <span>-</span>
      <FormField
        label="貸付上限額"
        type="number"
        placeholder="Placeholder"
        hint={`${maxAdvancePayment.toLocaleString()}円`}
        onChange={(e) => {
          setValue("maxAdvancePayment", Number(e.target.value))
        }}
        errorText={errors?.maxAdvancePayment?.message}
        value={maxAdvancePayment}
      />
      <span>, 0 ) +</span>
      <FormField
        label="頭金"
        type="number"
        placeholder="Placeholder"
        hint={`${downPayment.toLocaleString()}円`}
        onChange={(e) => {
          setValue("downPayment", Number(e.target.value))
        }}
        errorText={errors?.downPayment?.message}
        value={downPayment}
      />
      <span>)</span>
    </StyledCalculatorRowDiv>
  )
}

const StyledCalculatorRowDiv = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`
